
//Funcion para crear una URL amigable para el evento, se usaria en la vista EventoPublic
// Utiliza el nombre del evento separado en - y el id del evento para crear la URL
// Ejemplo: /e/nombre-del-evento/1234
export const generateEventoUrl = (evento) => {
  if (!evento || !evento.id) return '';
  
  const slug = evento.evento
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") //sacamos los acentos
    .trim()
    .replace(/[^\w\s-]/g, '') // sacamos caracteres especiales
    .replace(/\s+/g, '-') // los espacios pasan a ser -
    .replace(/-+/g, '-'); // evitamos doble -
  
  return `/e/${slug}/${evento.id}`;
};